import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";

export default class NavOverlay {
  constructor(navbar) {
    this.navbar = navbar;
    this.toggle = navbar.querySelector(".page-navbar__overlay-toggle");
    if (!this.toggle) return;

    this.pageFooter = document.getElementById("target_footer_bottom");
    this.a11ySkipLinks = document.querySelector("body > .skip-links");
    this.pageLogo = document.querySelector(".page-navbar__brand");

    this._init();
  }

  _init() {
    this.overlay = this.navbar.querySelector(".page-navbar__overlay");
    this.overlayInner = this.navbar.querySelector(
      ".page-navbar__overlay-inner",
    );
    this.menu = this.navbar.querySelector(".page-navbar__overlay-menu");
    this.toggle.addEventListener("click", this._handelToggleClick.bind(this));
    this.navItems = this.navbar.querySelectorAll("a");
    this.backdrop = this.navbar.querySelector(".page-navbar__overlay-backdrop");

    for (const navItem of this.navItems) {
      navItem.addEventListener("click", this._closeOverlay.bind(this));
    }

    this.backdrop.addEventListener("click", this._closeOverlay.bind(this));
  }

  _handelToggleClick() {
    var isOverlayOpen = this.isOverlayOpen || false;
    if (!isOverlayOpen) {
      this._openOverlay();
    } else {
      this._closeOverlay();
    }
  }

  _handleDesktopnavToggle(showDesktopNav) {
    if (showDesktopNav && this.isOverlayOpen) {
      this._closeOverlay();
    }
  }

  _openOverlay() {
    if (this.isOverlayOpen) return;
    this.isOverlayOpen = true;
    this.overlay.removeAttribute("inert");
    this.overlay.setAttribute("aria-hidden", "false");
    this.toggle.setAttribute("aria-expanded", "true");
    document.querySelector(".main-content").setAttribute("inert", "");
    this.pageFooter.setAttribute("inert", "");
    this.a11ySkipLinks.setAttribute("inert", "");
    this.pageLogo.setAttribute("inert", "");
    document.body.classList.add("navbar--overlay-is-open");
    disableBodyScroll(this.overlayInner);
  }

  _closeOverlay() {
    if (!this.isOverlayOpen) return;
    this.isOverlayOpen = false;
    this.overlay.setAttribute("inert", "");
    this.overlay.setAttribute("aria-hidden", "true");
    this.toggle.setAttribute("aria-expanded", "false");
    document.querySelector(".main-content").removeAttribute("inert");
    this.pageFooter.removeAttribute("inert");
    this.a11ySkipLinks.removeAttribute("inert");
    this.pageLogo.removeAttribute("inert");
    document.body.classList.remove("navbar--overlay-is-open");
    enableBodyScroll(this.overlayInner);
  }
}
